import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { getSelectedFilterValue } from "@coworker/apprestructured/src/shared/filters/utils/filter/filtervalue";

export const SORT_BY_ID = "sortedBy";

export const SORT_BY_VALUES = {
  TEAM_NAME_ALPHABETICAL_AZ: "teamNameAlphabeticalAZ",
  TEAM_NAME_ALPHABETICAL_ZA: "teamNameAlphabeticalZA",
  TEAM_SIZE_DESC: "teamSizeDesc",
  TEAM_SIZE_ASC: "teamSizeAsc",
  CREATED_AT_DESC: "createdAtDesc",
  CREATED_AT_ASC: "createdAtAsc",
};

export function useSortByFilter(
  filterValues: FilterValue[],
  enabled: boolean
): SelectFilter {
  const { t } = useTranslation();

  const defaultValue = {
    filterId: SORT_BY_ID,
    value: "",
  };

  const selected = getSelectedFilterValue(
    SORT_BY_ID,
    filterValues,
    defaultValue
  );

  const options = [
    {
      value: SORT_BY_VALUES.TEAM_NAME_ALPHABETICAL_AZ,
      title: t("alphabeticalOrderAZString"),
    },
    {
      value: SORT_BY_VALUES.TEAM_NAME_ALPHABETICAL_ZA,
      title: t("alphabeticalOrderZAString"),
    },
    { value: SORT_BY_VALUES.TEAM_SIZE_DESC, title: t("mostUsersString") },
    { value: SORT_BY_VALUES.TEAM_SIZE_ASC, title: t("leastUsersString") },
    { value: SORT_BY_VALUES.CREATED_AT_DESC, title: t("newestFirstString") },
    { value: SORT_BY_VALUES.CREATED_AT_ASC, title: t("oldestFirstString") },
  ];

  const selectedOption = options.find(
    (option) => option.value === selected.value
  );

  return {
    inputType: InputType.Select,
    filterType: FilterType.Sort,
    id: SORT_BY_ID,
    title: t("sortByFilterTitleString", {
      option: selectedOption?.title || "",
    }),
    options,
    enabled,
    defaultValue,
  };
}
